type FeatureAvailability = {
  featureName: string
  orkaTwo: boolean
  traditionalHA: boolean
}

const hearingAidFeatures: FeatureAvailability[] = [
  {
    featureName: 'Improve Mild to Moderately Severe Hearing Loss',
    orkaTwo: true,
    traditionalHA: true
  },
  {
    featureName: 'Improve Severe Hearing Loss',
    orkaTwo: false,
    traditionalHA: true
  },
  {
    featureName: 'Direct Streaming to Most Bluetooth Devices',
    orkaTwo: true,
    traditionalHA: false
  },
  {
    featureName: 'Charging Case as Power Bank',
    orkaTwo: true,
    traditionalHA: false
  },
  { featureName: 'Rechargeability', orkaTwo: true, traditionalHA: true },
  { featureName: 'Noise Reduction', orkaTwo: true, traditionalHA: true },
  {
    featureName: 'Adaptive Sound Directionality',
    orkaTwo: true,
    traditionalHA: true
  },
  {
    featureName: 'Hands-Free Calling for iOS',
    orkaTwo: true,
    traditionalHA: true
  },
  {
    featureName: 'Hands-Free Calling for Android',
    orkaTwo: true,
    traditionalHA: false
  },
  {
    featureName: 'Multi-Device Connectivity',
    orkaTwo: true,
    traditionalHA: true
  },
  { featureName: 'Media Streaming', orkaTwo: true, traditionalHA: true },
  { featureName: 'Remote Fine-Tuning', orkaTwo: true, traditionalHA: true },
  { featureName: 'App Control', orkaTwo: true, traditionalHA: true },
  { featureName: 'At-Home OTA', orkaTwo: true, traditionalHA: true }
]

export default hearingAidFeatures
